/**
 * Converts a hex color to RGB components.
 * Supports both full hex (#RRGGBB) and shorthand hex (#RGB) formats.
 * @param {string} hex The hex color string.
 * @return {number[]} The [r, g, b] components.
 */
export function hexToRgb(hex) {
  // Expand shorthand hex (#000 to #000000)
  if (hex.length === 4) hex = `#${hex[1]}${hex[1]}${hex[2]}${hex[2]}${hex[3]}${hex[3]}`;

  const hexRegExp = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i;
  const result = hexRegExp.exec(hex);
  if (!result) {
    console.error('Invalid hex color format');
    return [];
  }

  const [, r, g, b] = result;
  return [parseInt(r, 16), parseInt(g, 16), parseInt(b, 16)];
}
